import { Link } from '@fluentui/react';
import React from 'react';

export const patientAuthorizationJSX = (
  <p>
    I understand that the personal information I supply and certain information pertaining to the
    use of the ZORYVE™ Savings Card will be used by Arcutis Biotherapeutics, Inc. (Arcutis) and
    third parties working on behalf of Arcutis to reach out to me by email, to call or text me at
    the mobile number I have provided to market its product(s), to conduct market research and/or to
    provide me with materials about products, disease education, or financial assistance. Arcutis
    may also contact me through email, phone, or text and may use my information to evaluate and
    improve its services and program(s). I understand that I may stop Arcutis from contacting me at
    any time, without it impacting my ability to use the Savings Card, by ways outlined in the{' '}
    <Link
      style={{ color: 'black' }}
      target="_blank"
      href="https://www.arcutis.com/privacy"
      rel="noreferrer"
    >
      <u>Privacy Notice</u>
    </Link>
    . Do you agree to the ZORYVE Direct Savings Card Program Terms and Conditions and consent to use
    and disclosure of your Personal Information under the Arcutis{' '}
    <Link
      style={{ color: 'black' }}
      target="_blank"
      href="https://www.arcutis.com/privacy"
      rel="noreferrer"
    >
      <u>Privacy Notice</u>
    </Link>
    . Do you agree to the ZORYVE Direct Savings Card Program{' '}
    <Link
      style={{ color: 'black' }}
      target="_blank"
      href="https://www.zoryve.com/save-with-zoryve-direct?anchor=terms"
      rel="noreferrer"
    >
      <u>Terms and Conditions</u>
    </Link>{' '}
    and consent to use and disclosure of your Personal Information under the Arcutis{' '}
    <Link
      style={{ color: 'black' }}
      target="_blank"
      href="https://www.arcutis.com/privacy"
      rel="noreferrer"
    >
      <u>Privacy Policy</u>
    </Link>
    ?
  </p>
);
